import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, queryString } from "../api.js";
import { ErrorBox, Pager, fmtRelative } from "../components/helpers.jsx";

const LIMIT = 50;

export default function HwidBans() {
    const [data, setData] = useState({ rows: [], total: 0 });
    const [q, setQ] = useState("");
    const [offset, setOffset] = useState(0);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let alive = true;
        api.get("/api/admin/hwid-bans" + queryString({ q, limit: LIMIT, offset }))
            .then((d) => { if (alive) setData(d); })
            .catch((e) => { if (alive) setErr(e.message); });
        return () => { alive = false; };
    }, [q, offset]);

    return (
        <>
            <div className="page-header">
                <div>
                    <h1>HWID bans</h1>
                    <div className="sub">Identifier sets cascaded from banned subjects.</div>
                </div>
            </div>

            <ErrorBox>{err}</ErrorBox>

            <div className="table-wrap">
                <div className="table-toolbar">
                    <input placeholder="Search subject / identifier…" value={q}
                           onChange={(e) => { setOffset(0); setQ(e.target.value); }} />
                </div>
                <table className="data">
                    <thead>
                        <tr>
                            <th>Banned subject</th>
                            <th># identifiers</th>
                            <th>Reason</th>
                            <th>Banned</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.rows.length === 0 && (
                            <tr><td colSpan={4} className="text-dim" style={{ padding: 24, textAlign: "center" }}>
                                Nothing here yet
                            </td></tr>
                        )}
                        {data.rows.map((r) => (
                            <tr key={r.bannedSubject}>
                                <td className="mono">
                                    <Link to={`/hwid-bans/${encodeURIComponent(r.bannedSubject)}`}>
                                        {r.bannedSubject}
                                    </Link>
                                </td>
                                <td className="mono">{r.identifierCount}</td>
                                <td className="text-dim">{r.reason ?? "—"}</td>
                                <td title={new Date(r.bannedAt).toLocaleString()}>{fmtRelative(r.bannedAt)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Pager total={data.total} limit={LIMIT} offset={offset} onChange={setOffset} />
            </div>
        </>
    );
}
